<template>
    <v-container grid-list-xs fluid>
        <v-toolbar color="primary" dark dense>
            <v-toolbar-title>
                Shift and Truck Usage Report
            </v-toolbar-title>
        </v-toolbar>
        <v-container grid-list-xs fluid>
            <v-toolbar>
                <v-combobox v-model="truck" multiple  placeholder="Select truck" :items="trucks"
                    :rules="[
                        v => !!v || 'Required'
                    ]" required :item-text="'Truck'" :item-value="'TruckID'" auto-select-first></v-combobox>
                    <v-btn color="success" @click="exportExcel" class="mb-2 ml-6" small>Download <v-icon>mdi-microsoft-excel</v-icon></v-btn>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field label="Start Date" v-model="startDate" dense class="mr-2" v-mask="'####-##-##'"
                    hide-details></v-text-field>
                <v-text-field label="End Date" v-model="endDate" dense v-mask="'####-##-##'"
                    hide-details></v-text-field>
                <v-btn class="ml-3" color="secondary" @click="getShiftInfo" small>Search</v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table :headers="headers" :items="usage">

                    <template slot="body.append">
                        <tr>
                            <td colspan="8"></td>
                            <td class="text-left font-weight-bold">{{ Number(calculateTotal('OdoTotal', usage)).toFixed(2) }}
                            </td>
                            <td class="text-left font-weight-bold">{{ Number(calculateTotal('TotalHours', usage)).toFixed(2) }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-container>
        </v-container>
    </v-container>
</template>
<script>
// import moment from 'moment';
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function () {
        return {
            trucks: null,
            truck: null,
            endDate: null,
            startDate: null,
            usage: [],
            headers: [
                { text: 'Shift Date', value: 'Date' },
                { text: 'Shift', value: 'Shift' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'Truck', value: 'Truck' },
                { text: 'Odo Start', value: 'OdoStart' },
                { text: 'Odo End', value: 'OdoEnd' },
                { text: 'Shift Start Time', value: 'ShiftStartTime' },
                { text: 'Shift End Time', value: 'ShiftEndTime' },
                { text: 'Total KM', value: 'OdoTotal' },
                { text: 'Total Hrs', value: 'TotalHours' },

            ]
        }
    },
    mounted() {
        this.loadTrucks();
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Payroll';
            }
        }
    },
    methods: {

        calculateTotal(field, source) {
            return source.reduce((acc, item) => acc + Number(item[field]), 0);
        },
        getShiftInfo:async function () {
            const parms = {
                StartDate: this.startDate,
                EndDate: this.endDate,
                Truck: this.truck == null ? [] :await this.truck.map(x =>{
                    return x.TruckID;
                }) ,
            }
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('shift-detail/shift/truck/usage', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.usage = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;

                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        exportExcel:async function(){
            var parms = {
                StartDate: this.startDate,
                EndDate: this.endDate,
                Truck: this.truck == null ? [] :await this.truck.map(x =>{
                    return x.TruckID;
                }) ,
                Export:true,
            } 
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('shift-detail/shift/truck/usage', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = 'Shift and Truck Usage Report.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        loadTrucks: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + str.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.trucks = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
    }
};
</script>
